import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, commsHeader, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_COMS_CONFIG_LIST, GET_COMS_CONFIG_LIST_SUCCESS, GET_COMS_CONFIG_LIST_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getComsConfigList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/comms/configs`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...commsHeader,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMS_CONFIG_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMS_CONFIG_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMS_CONFIG_LIST_ERROR, payload: error });
  }
}

export function* watchComsConfigList() {
  yield takeEvery(GET_COMS_CONFIG_LIST, getComsConfigList);
}

function* getComsConfigListSaga() {
  yield all([fork(watchComsConfigList)]);
}

export default getComsConfigListSaga;
